import gradguardConfig from 'ui/config/gradguard.config';

export default defineAppConfig(gradguardConfig);
